import { Box, FormHelperText, Typography } from '@mui/material';
import { FormElementProps } from 'components/common/form';
import useBundleTranslation from 'i18n';
import { useFormState } from 'react-hook-form';
import IconMi from 'components/common/icon/IconMi';
import showdown from 'showdown';
import { prepareTextDataObject } from 'tools/tools';
const converter = new showdown.Converter();

export default function FormStaticLabel({ elementProps }: { elementProps: FormElementProps }) {
    const { t } = useBundleTranslation([elementProps.translationNS ?? 'main']);
    const { dirtyFields } = useFormState({ control: elementProps.form.hookFormControl });

    const isSection = elementProps.componentProps?.isSectionLabel;
    const name = elementProps.componentProps?.showNotesOnChange;
    const align = elementProps.componentProps?.align;
    const color = elementProps.componentProps?.color;
    const label = elementProps.componentProps.translate
        ? t(elementProps.componentProps.label)
        : elementProps.componentProps.label;
    const notes = elementProps.componentProps.translate
        ? t(elementProps.componentProps.notes)
        : elementProps.componentProps.notes;
    const showNotes = name ? notes && dirtyFields[name] : !!notes;
    const removeHeaderIndent = elementProps.componentProps?.removeHeaderIndent;
    const icon = elementProps.componentProps?.icon;
    const { text: helperTextValue, getFinalHtml: getHelperText } = prepareTextDataObject(
        elementProps.componentProps?.helperText ?? '',
    );

    return (
        <>
            {isSection ? (
                <Typography
                    variant="heading"
                    className={'heading-item'}
                    sx={{ pt: !removeHeaderIndent ? 2 : undefined }}
                >
                    {icon && <IconMi className={'heading-item__icon heading-icon'} icon={icon} />}
                    <Box component={'span'} className={'heading-item__label'}>
                        {label}
                    </Box>
                </Typography>
            ) : (
                <Typography
                    component="span"
                    dangerouslySetInnerHTML={{ __html: converter.makeHtml(label) }}
                    className={'form-static-label'}
                    variant={'body1'}
                    align={align}
                    sx={{ color, '& p': { m: 0 } }}
                ></Typography>
            )}
            {showNotes && (
                <Typography className="form-static-label-notes" variant={'body1'} align={align} sx={{ color }}>
                    {notes}
                </Typography>
            )}
            {helperTextValue && (
                <FormHelperText sx={{ marginLeft: 0 }} className={'markdown-holder'}>
                    {getHelperText(t)}
                </FormHelperText>
            )}
        </>
    );
}
